import {apiWithToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    getListAgency: (filters = {}) => apiWithToken.get(API_URL.LIST_AGENCY, {params: filters}, {loading: false}),
    updateAgency: (params) => apiWithToken.put(API_URL.LIST_AGENCY+`/${params.id}`, params)
};